/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import { Box, Button } from "@mui/material";
import { useForm } from "@/src/provider/Form/FormProvider";
import DialogModal from "@/src/components/DialogModal/DialogModal";
import { useLocation, useNavigate } from "react-router";
import MoreInfoIcon from "@/src/components/SvgIcon/MoreInfoIcon";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import wizardStyle from "@/src/components/Form/wizardStyle";

type LegalExpensesInsuranceProps = {
  submitProps: FormSubmitProps;
};

export default function LegalExpensesInsurance({ submitProps }: LegalExpensesInsuranceProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleSubmit } = useForm();

  const modalOpen = () => {
    navigate(location.pathname, { state: { jobInfoModalOpen: true } });
  };

  const modalClose = () => {
    navigate(-1);
  };

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Persönliche Angaben
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>
                Was ist Ihr aktueller Beruf?
                <Button fullWidth={true} variant={"text"} color={"primary"} onClick={modalOpen}>
                  <MoreInfoIcon sx={wizardStyle.leftIcon} /> Weitere Informationen
                </Button>
              </FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorTextField name="job" label="Aktueller Beruf" validators={[requiredValidator("Bitte geben Sie Ihren aktuellen Beruf an")]} />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
      <DialogModal open={!!(location.state && location.state.jobInfoModalOpen)} onClose={modalClose} title={"Weitere Informationen"}>
        <p>
          Entscheidend ist dabei nur Ihr <strong>aktueller</strong> Beruf. Wenn Sie zum Beispiel ausgebildete Erzieherin sind und jetzt als Verkäuferin
          arbeiten, tragen Sie bitte Verkäuferin ein. Wenn Sie aktuell Hausfrau, arbeitslos oder freigestellt sind, können Sie das hier ebenfalls angeben.
        </p>
      </DialogModal>
    </Paper>
  );
}
